// ================== BILLING INFO READ ================ //
export const BILLING_READ_REQUEST = 'billing info read requested';
export const BILLING_READ_SUCCESS = 'billing info read succeeded';
export const BILLING_READ_FAILURE = 'billing info read failed';

export function billingReadRequest() {
  return {
    type: BILLING_READ_REQUEST
  }
}

export function billingReadSuccess(response) {
  return {
    type: BILLING_READ_SUCCESS,
    payload: response,
  }
}

export function billingReadFailure(error, response) {
  return {
    type: BILLING_READ_FAILURE,
    error: error,
    response: response
  }
}

// ================== INVOICE READ ================ //
export const INVOICE_READ_REQUEST = 'fetching invoice info';
export const INVOICE_READ_SUCCESS = 'fetching invoice info success';
export const INVOICE_READ_FAILURE = 'fetching invoice info failure';

export function invoiceReadRequest() {
  return {
    type: INVOICE_READ_REQUEST
  }
}

export function invoiceReadSuccess(response) {
  return {
    type: INVOICE_READ_SUCCESS,
    payload: response,
  }
}

export function invoiceReadFailure(error, response) {
  return {
    type: INVOICE_READ_FAILURE,
    error: error,
    response: response
  }
}

// ================= SET COMPANY ID ============
export const SET_COMPANY_INFO = 'set the company info for the current user'
export function setCompanyInfo(companyInfo){
    return {
        type: SET_COMPANY_INFO,
        payload: companyInfo
    }
}
export const UPDATES_SUCCESS = 'update the company table'
export function updatesSuccess(updates){
    return {
        type: UPDATES_SUCCESS,
        payload: updates
    }
}

// ================== COMPANY PAYMENT STATUS =========================
export const SET_PAYMENT_STATUS = 'payment status set'
export function setPaymentStatus(paymentStatus){
    return {
        type: SET_PAYMENT_STATUS,
        payload: paymentStatus
    }
}


// ===== HISTORY ====
export const HISTORY_READ_REQUEST = 'request history of the finished tickets'
export const HISTORY_READ_SUCCESS= 'request history success'
export const HISTORY_READ_FAILURE = 'request history failed'

export function historyReadRequest(page){
    return { type: HISTORY_READ_REQUEST, currentPage: page }
}
export function historyReadSuccess(page, payload, count){
    return {
        type: HISTORY_READ_SUCCESS,
        page: page,
        payload: payload,
        count: count
    }
}
export function historyReadFailure(){
    return { type: HISTORY_READ_FAILURE}
}


// === STATS ===
export const STATS_TICKET_CREATED_REQUEST = 'request stats tickets created'
export const STATS_TICKET_CREATED_SUCCESS = 'request stats tickets created success'
export const STATS_TICKET_CREATED_ADDITION= 'tickets created add to graph'
export function statsTicketCreatedPostRequest(stats){
    return {type: STATS_TICKET_CREATED_REQUEST}
}
export function statsTicketCreatedPostSuccess(stats){
    return {type: STATS_TICKET_CREATED_SUCCESS, stats: stats}
}
export function statsTicketCreatedAdd(time, value){
    return {type: STATS_TICKET_CREATED_ADDITION, time: time, value: value}
}

export const STATS_LIVE_REQUEST= 'request live stats'
export const STATS_LIVE_SUCCESS= 'request live stats success'
export const STATS_LIVE_UPDATE_NBR = 'update current live stats with addition'
export function statsLiveSuccess(stats){
    return {type: STATS_LIVE_SUCCESS, stats: stats}
}
export function statsLiveUpdateNbr(key, value){
    return {type: STATS_LIVE_UPDATE_NBR, key: key, value: value}
}

export const STATS_TICKET_RESPONSE_REQUEST = 'request stats tickets response time'
export const STATS_TICKET_RESPONSE_SUCCESS = 'request stats tickets response time success'
export function statsTicketResponseTimePostSuccess(stats){
    return {type: STATS_TICKET_RESPONSE_SUCCESS, stats: stats}
}
export const STATS_TICKET_RESPONSE_ADDITION= 'request stats tickets response time add'
export function statsResponseTimeAdd(timeCreated, duration){
    return {type: STATS_TICKET_RESPONSE_ADDITION, time: timeCreated, second: duration}
}



// WEBPACK FOOTER //
// ./src/model/Company/actions.js